<template>
  <b-row>
    <b-col cols="9">
      <a
        @click="edit = true"
        v-if="!edit"
        class="text-dark text-hover-primary mb-1 fs-6"
        >{{ category.ICName }}</a
      >
      <input
        :ref="`field-${category.ICName}`"
        @keyup="checkKeyPress"
        type="text"
        v-if="edit"
        v-model="name"
        class="text-dark mb-1 fs-6"
      />
      <!-- <span class="text-muted fw-bold d-block">Movie Creator</span> -->
    </b-col>
    <b-col>
      <span class=""><a @click="prepEdit" v-if="!edit">Edit</a></span>
      <div v-if="edit">
        <span class="text-hover-primary"
          ><a @click="editCategoryConfirmation">Save</a></span
        >
        <span class="">&nbsp;|&nbsp;</span>
        <span class="text-hover-primary"
          ><a @click="edit = false">Cancel</a></span
        >
      </div>
    </b-col>
    <b-col>
      <a @click="deleteCategoryConfirmation" :class="loading ? 'disabled' : ''">
        <span
          v-if="loading"
          class="spinner-border spinner-border-sm align-middle ms-2"
        ></span>
        <svg
          v-if="!loading"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
            stroke="#060606"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M14 8L8 14"
            stroke="#060606"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M8 8L14 14"
            stroke="#060606"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path></svg
      ></a>
    </b-col>
    <ConfirmationModal
      :isLoadingConfirmation="loadingConfirmation"
      :isShowDialog="isShowConfirmationModal"
      :btnConfig="buttonConfiguration"
      :inputInfo="confirmationModalInfo"
      :inputColor="confirmationModalInfoColor"
      @eConfirm="determineOperation"
      @eCancel="defaultCancelOperation"
    />
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
  </b-row>
</template>

<script>
import { error } from "@/services/LoggerService";
import { ApiService } from "@/services/ApiService";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import mixins from "vue-typed-mixins";

export default mixins(SnackbarNotifierMixin, ConfirmationModalMixin).extend({
  name: "CategoryChip",
  props: {
    category: {
      required: true,
      type: Object,
    },
  },
  components: {
    ConfirmationModal,
    SnackbarNotifier,
  },
  data() {
    return {
      loading: false,
      edit: false,
      name: this.category.ICName,
      categoryId: this.category.Id,
      operation: "",
    };
  },
  methods: {
    async checkKeyPress(event) {
      if (event.keyCode == 13) await this.editCategoryConfirmation();
      if (event.keyCode == 27) this.edit = false;
    },
    prepEdit() {
      this.edit = true;
      this.$nextTick(() => {
        const element = this.$refs[`field-${this.category.ICName}`];
        if (element) element.focus();
      });
    },
    async determineOperation() {
      if (this.operation === "delete") await this.deleteCategory();
      if (this.operation === "edit") await this.editCategory();
    },
    deleteCategoryConfirmation() {
      this.showConfirmationModal({
        title: "Delete Category",
        message: `Are you sure you want to delete <b><em>${this.category.ICName}</em></b>?`,
      });
      this.operation = "delete";
    },
    async deleteCategory() {
      try {
        this.loading = true;
        this.startConfirmationLoading();
        let result = await ApiService.Instance.deleteItemCategories(
          this.category.Id
        );
        if (result) {
          this.showNotifier({
            message: `Successfully Deleted ${this.category.ICName}`,
            snackbarType: "success",
          });
          this.$emit("edited");
        }
        this.loading = false;
        this.stopConfirmationLoading();
        this.operation = "";
      } catch (e) {
        this.showNotifier({
          message: `Failed To Delete ${this.category.ICName}`,
          snackbarType: "error",
        });
        this.operation = "";
        this.stopConfirmationLoading();
        this.loading = false;
        error(e);
      }
    },
    editCategoryConfirmation() {
      this.showConfirmationModal({
        title: "Renaming Category",
        message: `Are you sure you want to rename <b><em>${this.category.ICName}</em></b> to <b><em>${this.name}</em></b>?`,
      });
      this.operation = "edit";
    },
    async editCategory() {
      try {
        this.startConfirmationLoading();
        let result = await ApiService.Instance.editItemCategories([
          {
            id: this.category.Id,
            newName: this.name,
          },
        ]);
        if (result) {
          this.showNotifier({
            message: `Successfully Renamed`,
            snackbarType: "success",
          });
          this.edit = false;
          this.$emit("edited");
        }
        this.stopConfirmationLoading();
        this.operation = "";
      } catch (e) {
        this.showNotifier({
          message: `Failed To Rename`,
          snackbarType: "error",
        });
        this.stopConfirmationLoading();
        this.operation = "";
        error(e);
      }
    },
  },
});
</script>

<style></style>
